document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('autoplay-marquee')) {
    customElements.define(
      'autoplay-marquee',
      class AutoplayMarquee extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.autoplay-marquee__track');
          if (!this.track) return;

          this.mediaQuery = window.matchMedia('(min-width: 750px)');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          this.speed = parseFloat(this.dataset.speed) || 60;
          this.repeats = parseInt(this.dataset.repeats, 10) || 4;

          this.reducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          this.marqueeSwiper = null;

          this.playButton = this.querySelector('.marquee-btn-container .icon-play');
          this.pauseButton = this.querySelector('.marquee-btn-container .icon-pause');

          this.playButton?.addEventListener('click', () => {
            this.resume();
            this.querySelector('.marquee-btn-container')?.classList.remove('active');
          });

          this.pauseButton?.addEventListener('click', () => {
            this.pause();
            this.querySelector('.marquee-btn-container')?.classList.add('active');
          });

          this.resizeObserver = new ResizeObserver(() => {
            if (this.mediaQuery.matches) {
              this.calculateDuration();
            }
          });
        
          this.resizeObserver.observe(this.track);
          this.handleBreakpointChange = () => {
            this.updateMode();
          };
        
          this.mediaQuery.addEventListener('change',this.handleBreakpointChange);
          this.reducedMotion.addEventListener('change',this.handleBreakpointChange);
          this.handleFocusIn = () => this.pause();
          this.handleFocusOut = () => this.resume();
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          this.updateMode();
        }
      
        removeDuplicateItems() {
          const seen = new Set();
          this.track.querySelectorAll('.autoplay-marquee__item').forEach((item) => {
            const id = item.dataset.id;
      
            if (!id) return;

            if (seen.has(id)) {
              item.remove();
            } else {
              seen.add(id);
            }
          });
        }
      
        updateMode() {
          if (this.mobileQuery.matches) {
            this.removeDuplicateItems();
            this.initSwiper();
            this.stopMarquee();
          } else {
            this.destroySwiper();
            this.startMarquee();
          }
        }

        initSwiper() {
          if (this.marqueeSwiper) return;
          this.classList.add('swiper');
          this.track.classList.add('swiper-wrapper');
          this.track.querySelectorAll('.autoplay-marquee__item').forEach((slide) => {
            slide.classList.add('swiper-slide');
          });

          let pagination = this.querySelector('.swiper-pagination');

          if (!pagination) {
            pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            this.appendChild(pagination);
          }

          this.marqueeSwiper = new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
            speed: 500,
            loop: true,
            freeMode: false,
            allowTouchMove: true,
            mousewheel: {
              forceToAxis: true,
              sensitivity: 1,
              thresholdDelta: 30,
            },
            pagination: {
              el: pagination,
              clickable: true,
            }
          });
        }

        destroySwiper() {
          if (!this.marqueeSwiper) return;

          this.marqueeSwiper.destroy(true, true);
          this.marqueeSwiper = null;
          this.classList.remove('swiper');
          this.track.classList.remove('swiper-wrapper');
          this.track.querySelectorAll('.autoplay-marquee__item').forEach((slide) => {
            slide.classList.remove('swiper-slide');
          });
          this.querySelector('.swiper-pagination')?.remove();
        }

        startMarquee() {
          if (this.reducedMotion.matches) {
            this.stopMarquee();
            return;
          }
          this.calculateDuration();
          this.track.style.animationPlayState = 'running';
        }

        stopMarquee() {
          this.track.style.animationPlayState = 'paused';
        }

        calculateDuration() {
          if (!this.track.scrollWidth) return;

          const singlePassWidth = this.track.scrollWidth / this.repeats;
          const duration = singlePassWidth / this.speed;
          this.track.style.setProperty('--marquee-duration',`${duration}s`);
        }

        pause() {
          if (this.mediaQuery.matches) {
            this.track.style.animationPlayState = 'paused';
          }
        }

        resume() {
          if (this.mediaQuery.matches && !this.reducedMotion.matches) {
            this.track.style.animationPlayState = 'running';
          }
        }

        disconnectedCallback() {
          this.destroySwiper();
          this.resizeObserver?.disconnect();
          this.mediaQuery?.removeEventListener('change',this.handleBreakpointChange);
          this.reducedMotion?.removeEventListener('change',this.handleBreakpointChange);
          this.removeEventListener('focusin',this.handleFocusIn);
          this.removeEventListener('focusout',this.handleFocusOut);
        }
      }
    );
  }
});
